/**
 * Supabase Client
 * Uses centralized environment configuration with cloud fallback
 */

import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { supabaseConfig } from '@/lib/config/environment';

export const supabase = createClient<Database>(supabaseConfig.url, supabaseConfig.anonKey, {
  global: {
    headers: {
      'x-client-info': 'drug-web',
    },
  },
});

export default supabase;
